<template>
  <div>
    <a-card>
      <div>
        <a-form layout="horizontal">
          <a-row>
            <a-col :md="6" :sm="24">
              <a-form-item
                label="状态"
                :labelCol="{ span: 5 }"
                :wrapperCol="{ span: 18, offset: 1 }"
              >
                <a-select
                  placeholder="全部"
                  :allowClear="true"
                  v-model="params.rotationStatus"
                >
                  <a-select-option :value="0">已发布</a-select-option>
                  <a-select-option :value="1">未发布</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item
                label="标题"
                :labelCol="{ span: 5 }"
                :wrapperCol="{ span: 18, offset: 1 }"
              >
                <a-input v-model="params.rotationTitle" placeholder="请输入" />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-button
                style="margin-left: 8px; margin-top: 3px"
                @click="loadData"
                type="primary"
                >查询</a-button
              >
            </a-col>
          </a-row>
        </a-form>
      </div>
      <div class="btn-group">
        <a-button type="primary" @click="create">新建</a-button>
        <a-button
          :disabled="!selectedRowKeys.length"
          @click="updateStatus(selectedRowKeys.join(','), 0)"
          >发布</a-button
        >
        <a-button
          :disabled="!selectedRowKeys.length"
          @click="updateStatus(selectedRowKeys.join(','), 1)"
          >取消发布</a-button
        >
      </div>
      <div>
        <a-table
          ref="table"
          :columns="columns"
          :data-source="data"
          :row-selection="{
            onChange: onTableRowSelectionChange,
            selectedRowKeys: selectedRowKeys,
          }"
          :pagination="paginationProps"
          rowKey="rotationId"
        >
          <template slot="img" slot-scope="text">
            <img v-if="text" style="max-height: 30px" :src="text" alt="图片" />
          </template>
          <template slot="remark" slot-scope="text">
            <div v-html="text" class="desc"></div>
          </template>
          <template slot="status" slot-scope="row">
            {{ row.rotationStatus == 0 ? "已发布" : "未发布"
            }}{{ row.rotationTop == 0 ? " / 置顶" : "" }}
          </template>
          <span slot="action" slot-scope="row">
            <a-button type="link" size="small" @click="edit(row)"
              >编辑</a-button
            >
            <a-button
              type="link"
              size="small"
              @click="
                updateStatus(row.rotationId, row.rotationStatus == 0 ? 1 : 0)
              "
              >{{ row.rotationStatus == 0 ? "取消发布" : "发布" }}</a-button
            >
            <a-button
              type="link"
              size="small"
              @click="
                updateTop(row.rotationId, row.rotationTop == 0 ? 1 : 0)
              "
              >{{ row.rotationTop == 0 ? "取消置顶" : "置顶" }}</a-button
            >
            <a-popconfirm
              title="确认删除吗?"
              ok-text="是"
              cancel-text="否"
              @confirm="del(row)"
            >
              <a-button type="link" size="small">删除</a-button>
            </a-popconfirm>
          </span>
        </a-table>
      </div>
    </a-card>
    <a-modal
      v-model="createdModal"
      :title="currentFrom.rotationId ? '编辑' : '新建'"
      @ok="submit"
    >
      <a-form-model ref="ruleForm" :model="currentFrom" :rules="rules" >
         <a-form-model-item
          label="标题"
          :labelCol="{ span: 5 }"
          :wrapperCol="{ span: 17 }"
          prop="rotationTitle"
        >
          <a-input
            v-model="currentFrom.rotationTitle"
            placeholder="请输入标题名称"
          />
        </a-form-model-item>
        
        <a-form-model-item
          label="封面图"
          :labelCol="{ span: 5 }"
          :wrapperCol="{ span: 17 }"
          extra="图片尺寸:750x300像素,支持png格式的图片,大小不超过1M"
          prop="rotationPicture"
        >
          <c-upload
            name="file"
            list-type="picture-card"
            class="avatar-uploader"
            :headers="headers"
            :show-upload-list="false"
            :action="uploadFileUri"
            :before-upload="beforeUpload"
            @change="handleChange"
          >
            <img
              v-if="currentFrom.rotationPicture"
              :src="currentFrom.rotationPicture"
              alt="avatar"
            />
            <div v-else>
              <a-icon :type="loadingFile ? 'loading' : 'plus'" />
              <div class="ant-upload-text">Upload</div>
            </div>
          </c-upload>
        </a-form-model-item>
        <a-form-model-item
          label="页面形式"
          :labelCol="{ span: 5 }"
          :wrapperCol="{ span: 17 }"
        >
          <a-radio-group name="radioGroup" v-model="currentFrom.pageShape">
            <a-radio :value="0">文章</a-radio>
            <a-radio :value="1">跳转链接</a-radio>
          </a-radio-group>
        </a-form-model-item>
        <a-form-model-item
          v-show="currentFrom.pageShape == 0"
          label="附件"
          :labelCol="{ span: 5 }"
          :wrapperCol="{ span: 17 }"
        >
           <c-upload
            name="file"
            :action="uploadFileUri"
            accept-type="file"
            :show-upload-list="currentFrom.files.length>0"
            @change="handleFileChange"
            :file-list="currentFrom.files"
          >
            <a-button> <a-icon type="upload" /> 上传附件 </a-button>
          </c-upload>
        </a-form-model-item>
        <a-form-model-item
          v-show="currentFrom.pageShape == 1"
          label="跳转链接"
          :labelCol="{ span: 5 }"
          :wrapperCol="{ span: 17 }"
          :key="2"
        >
          <a-input v-model="currentFrom.rotationAddress" />
        </a-form-model-item>
        <div v-show="currentFrom.pageShape == 0">
          <v-editor v-model="currentFrom.rotationRemark" :key="1"></v-editor>
        </div>
      </a-form-model>
    </a-modal>
  </div>
</template>

<script>
//eslint-disable-next-line
import {
  getAllRotations,
  saveRotations,
  editOneRotation,
  removeRotation,
  updateStatus,
  rotationToTop,
  rotationNotToTop
} from "@/services/banner";
import uploadFileUri from "@/services/uploadFileUri";
const rules = {
  rotationTitle: [{ required: true, message: '请输入标题', trigger: 'change' }],
  rotationPicture: [{ required: true, message: '请上传封面图', trigger: 'change' }],
}
const columns = [
  {
    title: "标题",
    dataIndex: "rotationTitle",
  },
  {
    title: "封面图",
    dataIndex: "rotationPicture",
    scopedSlots: {
      customRender: "img",
    },
  },
  {
    title: "摘要",
    dataIndex: "rotationRemark",
     scopedSlots: {
      customRender: "remark",
    },
  },
  {
    title: "显示状态",
    scopedSlots: {
      customRender: "status",
    },
  },
  {
    title: "创建时间",
    dataIndex: "createTime",
    
  },
  {
    title: "操作",
    key: "action",
    scopedSlots: {
      customRender: "action",
    },
  },
];
const notice = 1;

const data = [];
const currentFrom = {
  rotationId: undefined, //
  rotationTitle: undefined, //轮播标题
  rotationPicture: undefined, //轮播图片
  pageShape: 0, //页面形式(0:文章描述;1:跳转链接)
  rotationSort: undefined, //轮播排序;数越小轮播月靠前
  rotationRemark: undefined, //轮播文章描述
  rotationAddress: undefined, //轮播跳转地址
  files:[],
};
export default {
  name: "NoticeManagement",
  data() {
    return {
      rules,
      paginationProps: {
        pageSize: 10,
        showTotal: (total) => `共${total}条`,
        current: 1,
        total: 0,
        onChange: (current) => this.onPageChange(current),
      },
      data,
      columns,
      selectedRowKeys: [],
      loading: false,
      loadingFile: false,
      createdModal: false,
      headers: {
        authorization: "authorization-text",
      },
      params: {
        rotationType: notice,
        page: 1,
        limit: 10,
        rotationStatus: undefined,
        rotationTitle: undefined,
      },
      currentFrom,
      uploadFileUri,
    };
  },
  mounted() {
    this.loadData();
  },
  methods: {
    beforeUpload(file) {
      const isJpgOrPng =
        file.type === "image/jpeg" || file.type === "image/png";
      if (!isJpgOrPng) {
        this.$message.error("You can only upload JPG file!");
      }
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message.error("Image must smaller than 2MB!");
      }
      return isJpgOrPng && isLt2M;
    },
    handleChange(info) {
      if (info.file.status === "uploading") {
        this.loadingFile = true;
        return;
      }
      if (info.file.status === "done") {
        this.currentFrom.rotationPicture = info.file.response.data.filePath;
        this.loadingFile = false;
      } else if (info.file.status === "error") {
        this.$message.error(`${info.file.name} 上传失败.`);
      }
    },
    handleFileChange(info) {
      let fileList = [...info.fileList];

      // 2. read from response and show file link
      fileList = fileList.map(file => {
        let f = {name: file.name, status: file.status, uid: file.uid};
        if (file.response) {
          // Component will show file.url as link
          f.url = file.response.data.filePath;
        }
        return f;
      }).filter(f=>f.url);

      this.currentFrom.files = fileList;
    },
    onTableRowSelectionChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys;
    },
    onPageChange(page) {
      this.params.page = page;
      this.loadData();
    },

    edit(row) {
      // this.currentFrom.files。
      this.currentFrom = Object.assign(this.currentFrom , row , { rotationType: notice });
      this.$set(this.currentFrom, "files",  row.files?JSON.parse(row.files):[]);
      this.createdModal = true;
    },
    create() {
      this.currentFrom = Object.assign({
        rotationType: notice,
        rotationTitle: undefined, //轮播标题
        rotationPicture: undefined, //轮播图片
        pageShape: 0, //页面形式(0:文章描述;1:跳转链接)
        rotationSort: 0, //轮播排序;数越小轮播月靠前
        rotationRemark: undefined, //轮播文章描述
        rotationAddress: undefined, //轮播跳转地址
        files:[],
      });
      this.createdModal = true;
    },
    async submit() {
      this.$refs.ruleForm.validate(async(valid) => {
        if (valid) {
          let currentFrom = Object.assign({},this.currentFrom,{files:JSON.stringify(this.currentFrom.files)});
         if (currentFrom.rotationId) {
            await editOneRotation(currentFrom);
          } else {
            await saveRotations(currentFrom);
          }
          this.$message.success("操作成功");
          this.createdModal = false;
          this.search();
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    async loadData() {
      this.selectedRowKeys = [];
      const d = await getAllRotations(this.params);
      this.data = [];
      this.data = d.records;
      this.paginationProps.current = d.current;
      this.paginationProps.total = d.total;
    },
    search(){
      this.onPageChange(1);
    },
    async del(row) {
      await removeRotation({ rotationId: row.rotationId });
      this.$message.success("操作成功");
      this.search();
    },
    async updateStatus(rotationIds,status) {
      await updateStatus({
        rotationIds: rotationIds,
        rotationStatus: status,
      });
      this.$message.success("操作成功");
      this.search();
    },
    async updateTop(rotationId, top){
      if(top==0){
        await rotationToTop({
          rotationId: rotationId,
        });
      }else{
        await rotationNotToTop({
          rotationId: rotationId,
        });
      }
      
      this.$message.success("操作成功");
      this.search();
    },
  },
};
</script>

<style lang="less" scoped>
.desc {
  max-width: 100px;
  height: 20px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
</style>
<style>
.ant-form-explain,
.ant-form-extra {
  font-size: 12px;
}
</style>
